import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=c59ca8c6&"
import script from "./Framework.vue?vue&type=script&lang=ts&"
export * from "./Framework.vue?vue&type=script&lang=ts&"
import style0 from "./Framework.vue?vue&type=style&index=0&id=c59ca8c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports